export default __webpack_public_path__ + "static/media/Davina-Duerr-2024.2e068943.jpg";